import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SourceProfileTable from "./SourceProfileTable";
import CreateSource from "./CreateSource";
import Edit from "../migrations/Edit";
import { showToast } from "../Buttons/Toaster";
import LogModels from "../migrations/LogModel";
import ViewSummary from "./ViewVisualSummary";
import SourceProgress from "./SourceProgress";

function SourceProfile() {
  const location = useLocation();

  const [showCreateSource, setShowCreateSource] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [forceTooltipJobId, setForceTooltipJobId] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [logshow, setLogshow] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [selectedJobName, setSelectedJobName] = useState(null);
  const [viewshow, setViewshow] = useState(false);
  const [selectedJobIdForSummary, setSelectedJobIdForSummary] = useState(null);
  const [showProgress, setShowProgress] = useState(false);
  const [selectedJobIdForProgress, setSelectedJobIdForProgress] =
    useState(null);
  const [selectedJobNameForProgress, setSelectedJobNameForProgress] =
    useState(null);

  const handleViewVisualSummary = (jobId) => {
    setSelectedJobIdForSummary(jobId);
    setViewshow(true);
  };
  const handleViewProgress = (jobId, jobName) => {
    setSelectedJobIdForProgress(jobId);
    setSelectedJobNameForProgress(jobName);
    setShowProgress(true);
  };

  // Modify handleSourceCreated to accept jobId
  const handleSourceCreated = (jobId) => {
    setRefreshKey((prev) => prev + 1); // Force refresh of both tabs
    setShowCreateSource(false);

    if (jobId) {
      setForceTooltipJobId(jobId);
      setTooltipVisible(true);

      setTimeout(() => {
        setTooltipVisible(false);
        setForceTooltipJobId(null);
      }, 5000);
    }
  };

  //open model for reference refer home page
  useEffect(() => {
    if (location.state?.openCreateModal) {
      setShowCreateSource(true);
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    if (!showCreateSource) {
      setRefreshKey((prev) => prev + 1);
    }
  }, [showCreateSource]);

  useEffect(() => {
    if (!showCreateSource) {
      setRefreshKey((prev) => prev + 1);
    }
  }, [showCreateSource]);
  const handleViewLogs = (jobId, jobName) => {
    setSelectedJobId(jobId);
    setSelectedJobName(jobName);
    setLogshow(true);
  };

  const handleJobSave = () => {
    setRefreshKey((prev) => prev + 1);
  };
  const handleCloseProgress = () => {
  setShowProgress(false);
  setRefreshKey((prev) => prev + 1); // Refresh the table
};

  return (
    <div className="tab_content">
      <div className="page-content">
        <div className="container-fluid">
          <SourceProfileTable
            refreshKey={refreshKey}
            setRefreshKey={setRefreshKey} // Add this line
            onCreateSourceClick={() => setShowCreateSource(true)}
            onEditJob={setSelectedJob} // Pass the setter for selected job
            setShowEdit={setShowEdit} // Pass the setter for edit panel
            forceTooltipJobId={forceTooltipJobId}
            tooltipVisible={tooltipVisible}
            onViewLogs={handleViewLogs} // Pass the handler to the table
            onViewVisualSummary={handleViewVisualSummary}
            onViewProgress={handleViewProgress}
          />
        </div>
      </div>
   
{showProgress && (
  <SourceProgress
    jobId={selectedJobIdForProgress}
    jobName={selectedJobNameForProgress}
    onClose={handleCloseProgress}
    onMinimize={handleCloseProgress}
  />
)}
      {/* Blur overlay - combine conditions for both modals */}
      <div
        className={`rightbar-overlay ${
          showCreateSource || showEdit || logshow || viewshow
            ? "d-block"
            : "d-none"
        }`}
      ></div>

      {viewshow && (
        <ViewSummary
          viewshow={viewshow}
          viewsetShow={setViewshow}
          jobId={selectedJobIdForSummary}
          apiEndpoint={`${process.env.REACT_APP_API_URL_SOURCE_PROFILER}/job_summary`}
        />
      )}
      {/* Create Source Panel */}
      {showCreateSource && (
        <CreateSource
          show={showCreateSource}
          setShow={setShowCreateSource}
          onSaveCreate={handleSourceCreated}
        />
      )}

      {/* Edit Panel */}
      {showEdit && (
        <Edit
          show={showEdit}
          setShow={setShowEdit}
          job={selectedJob}
          onSave={handleJobSave}
          apiEndpoint={`${process.env.REACT_APP_API_URL_SOURCE_PROFILER}/edit_job`}
        />
      )}
      {logshow && (
        <LogModels
          logshow={logshow}
          logsetShow={setLogshow}
          jobId={selectedJobId}
          jobName={selectedJobName}
          moduleType="sourceProfiler"
        />
      )}
    </div>
  );
}

export default SourceProfile;
